import {
  faCheck,
  faExclamationCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Icon } from 'src/components/Icon';
import { Skeleton } from 'src/components/Skeleton';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

import { ActionsList } from './ActionsList';
import {
  blockingReasonBodySx,
  blockingReasonIconSx,
  blockingReasonRowSx,
} from './blockingReasonStyles';

export function BlockingReasonRow({
  title,
  message,
  actions,
  color = 'error',
}: {
  title: string;
  message: string;
  actions?: ButtonPropsWithLabel[];
  color?: 'error' | 'success';
}) {
  const isSuccess = color === 'success';

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={1}
      sx={{
        ...blockingReasonRowSx,
        bgcolor: `${color}.backgroundSoft`,
        borderColor: `${color}.borderRegular`,
        alignItems: { xs: 'stretch', sm: 'center' },
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          flex: 1,
          minWidth: 0,
          alignItems: 'center',
        }}
      >
        <Icon
          icon={isSuccess ? faCheck : faExclamationCircle}
          size="small"
          sx={{ ...blockingReasonIconSx, color: `${color}.solid` }}
        />

        <Stack spacing={0} sx={blockingReasonBodySx}>
          <Typography variant="h6" sx={{ color: `${color}.text` }}>
            {title}
          </Typography>
          <Typography variant="body2" sx={{ color: `${color}.text` }}>
            {message}
          </Typography>
        </Stack>
      </Stack>

      {!!actions && (
        <Stack
          sx={{
            flexShrink: 0,
            width: { xs: '100%', sm: 'auto' },
            alignSelf: { xs: 'stretch', sm: 'auto' },
            pl: { xs: 3.5, sm: 0 },
          }}
        >
          <ActionsList actions={actions} />
        </Stack>
      )}
    </Stack>
  );
}

export function BlockingReasonFallback() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={1}
      sx={{
        ...blockingReasonRowSx,
        alignItems: { xs: 'stretch', sm: 'center' },
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{ flex: 1, minWidth: 0, alignItems: 'flex-start' }}
      >
        <Icon
          icon={faExclamationCircle}
          size="small"
          sx={blockingReasonIconSx}
        />
        <Stack spacing={0} sx={blockingReasonBodySx}>
          <Skeleton variant="text" width="50%" height={24} />
          <Skeleton variant="text" width="70%" height={24} />
        </Stack>
      </Stack>
    </Stack>
  );
}
